import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../../../component/Page'
import TitlePage from '../../../../component/TitlePage'
import { Box, Button, Checkbox, FormControl, FormControlLabel, MenuItem, Pagination, Select, Skeleton, TextField } from '@mui/material'
import InputSearch from '../../../../component/InputSearch'
import dayjs from 'dayjs'
import AddButton from '../../../../component/AddButton'
import ListLayout from '../../../../component/listLayout'
import { getBranchList, getRawSeedMovementsList } from '../../services/api'

export default function PaidForMarketingList() {
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let id = searchParams.get('id') || ''
    let b = searchParams.get('b') || 'all'
    let l = searchParams.get('l') || ''
    let c = searchParams.get('c') || ''
    let sum = searchParams.get('sum') || ''
    let page = searchParams.get('page') || '1'
    let index = searchParams.get('index') || ''

    const [data, setData] = useState([])
    const [rowsPerPage] = useState(10);
    const { profile } = useSelector(state => state.profile)
    const [branchs, setBranchs] = useState([])

    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getRawSeedMovementsList(l, sum, b, c, page, rowsPerPage, 'จ่าย', 'หลังปรับปรุง')
            setData(data)
            setLoading(false)
        }
        getList()
    }, [l, sum, b, c, page, rowsPerPage])
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        getBranch()
    }, [])

    // const head = [
    //     'ที่',
    //     'ศูนย์เมล็ดพันธุ์ข้าว',
    //     'พันธุ์',
    //     'ชั้นพันธุ์',
    //     'ฤดู',
    //     'ปี',
    //     'ล็อตที่',
    //     'ปริมาณ (กิโลกรัม)',
    //     // 'จำนวนวันที่อยู่ในคลัง',
    //     'ดำเนินการ'
    // ]
    // const body = data?.items?.map((x, i) => {

    //     return {
    //         id: x?.DocumentNo,
    //         item1: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
    //         item2: x?.BranchNo?.BranchName,
    //         item3: '-',
    //         item4: '-',
    //         item5: '-',
    //         item6: '-',
    //         item7: '-',
    //         item8: '-',
    //         // item9: '-',
    //         item9: [<Link to={`/raw/paidformarketing/${x?.DocumentNo}`} onClick={() => setSearchParams({ id: x?.DocumentNo, page: page, q: q, b: b })}>
    //             <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
    //         </Link>]
    //         ,


    //     }
    // })
    return (
        // <ListLayout title={'รายการจ่ายให้งานตลาด'} action={<>
        //     <AddButton link={'/raw/paidformarketing/add'} />
        //     {
        //         profile?.BranchNo?.BranchNo === '00' &&
        //         <Box className="col-lg-2 col-md-12 ">
        //             <Box className='backgroundField' sx={{ marginRight: '20px' }}>
        //                 <FormControl variant="standard" fullWidth >
        //                     <Select value={b || 'all'}
        //                         onChange={e => setSearchParams({ q: q, b: e.target.value })}
        //                         disableUnderline
        //                         MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
        //                     >
        //                         <MenuItem value='all'>ทั้งหมด</MenuItem>
        //                         {branchs?.map((x, i) => (
        //                             <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
        //                         ))}
        //                     </Select>
        //                 </FormControl>
        //             </Box>
        //         </Box >
        //     }
        //     <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} placeholder={"ค้นหา เลขที่เอกสาร"} />
        // </>} loading={loading} head={head} body={body} pagination={{
        //     count: data?.meta?.totalPages,
        //     page: +page,
        //     event: { q: q, b: b, id: id }
        // }} id={id} />
        <Page>
            <TitlePage title='รายการจ่ายให้งานตลาด' action={
                <>
                    {/* <AddButton link={'/materials/materials-expenses/add'} /> */}
                    <div class="col-lg-3 col-md-6 d-flex align-items-center justify-content-center">
                        <FormControlLabel control={<Checkbox checked={sum === 'true' ? true : false} onChange={e => setSearchParams({ sum: e.target.checked, l: l, b: b, c: c })} />} label="รวมรายพันธุ์" />
                    </div>
                    <AddButton link={'/raw/paidformarketing/add'} />

                    {
                        profile?.BranchNo?.BranchNo === '00' &&
                        <Box className="col-lg-2 col-md-12 ">
                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={b || ''}
                                        onChange={e => setSearchParams({ sum: sum, c: c, b: e.target.value, l: l })}
                                        disableUnderline
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ศูนย์ทั้งหมด</MenuItem>
                                        {branchs?.map((x, i) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box >
                    }

                    {/* <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} placeholder={"ค้นหา เลขที่เอกสาร"} /> */}

                    <div class="col-lg-3 col-md-12 text-end" >
                        <Box className='backgroundField' style={{ marginRight: '20px' }}>
                            <TextField value={c} onChange={e => setSearchParams({ sum: sum, c: e.target.value, b: b, l: l, })} variant="standard" fullWidth placeholder="ค้นหา พันธ์ุ"
                                InputProps={{ disableUnderline: true }}
                            />
                        </Box>
                    </div>
                    <InputSearch value={l} onChange={e => setSearchParams({ sum: sum, l: e.target.value, b: b, c: c, })} placeholder={"ค้นหาเลขที่ล็อต"} />
                </>
            } />
            <div class="receive-list row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :

                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center">ที่</th>
                                    {profile?.BranchNo?.BranchNo === '00' && <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>}
                                    <th class="text-center">พันธุ์</th>
                                    <th class="text-center"> ชั้นพันธุ์</th>
                                    <th class="text-center">ฤดู</th>
                                    <th class="text-center">ปี</th>
                                    {sum !== 'true' && <th class="text-center">ล็อตที่</th>}
                                    <th class="text-center">ปริมาณ (กิโลกรัม)</th>
                                    {/* {sum !== 'true' && <th class="text-center">จำนวนวันที่อยู่ในคลัง</th>} */}
                                    <th class="text-center">ดำเนินการ</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {data?.items?.map((x, i) => (
                                    <tr className={`${i}` === index ? 'active' : ''}>
                                        <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                        {profile?.BranchNo?.BranchNo === '00' && <td className="text-center">{x?.BranchName}</td>}
                                        <td class="text-center">{x?.CatalogName}</td>
                                        <td class="text-center">{x?.ClassName}</td>

                                        <td class="text-center">
                                            <span style={{ fontWeight: "bold", color: x?.Season === 'ฝน' ? '#0D9206' : 'brown' }}> {x?.Season}</span>
                                        </td >
                                        <td class="text-center">{x?.Year}</td>
                                        {sum !== 'true' && <td class="text-center">{x?.Lot}</td >}
                                        <td class="text-center">{(+x?.Qty)?.toLocaleString()}</td>
                                        {/* {sum !== 'true' && <td class="text-center"><span style={{ color: x.DaysInStock > 240 ? '#E82900' : x.DaysInStock <= 180 ? '#000' : '#ECA904' }}>{x?.DaysInStock}</span></td >} */}
                                        <td class="text-center"><Link to={`/raw/paidformarketing/${x?.DocumentNo}`} onClick={() => setSearchParams({ id: x?.DocumentNo, page: page, q: q, b: b, index: i,sum: sum })}>
                                        <Button variant='contained' sx={{ background: x?.DocumentStatus === 'N' ? 'red' : '#fbbe66', ':hover': { background: x?.DocumentStatus === 'N' ? 'red' : '#eda844' } }}>{x?.DocumentStatus === 'N' ? 'ยกเลิก' : 'เรียกดู'}</Button>
                                        </Link></td>
                                    </tr >
                                ))}

                            </tbody >
                        </table >
                    </div >}
                <div class="col-md-12 text-center mt-4">
                    <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, l: l, c: c, b: b, id: id,sum: sum })} shape="rounded" />
                </div>
            </div >
        </Page>

    )
}
